import * as moment from 'moment';

import { formatCurrency } from '../../utils';


type GroupBy = 'QUARTERS' | 'MONTHS' | 'WEEKS';

function formatCategoriesAsDates({ groupBy, categories }: { groupBy: GroupBy, categories: Array<string> }) {
	const quarters = {
		1: 'I',
		2: 'II',
		3: 'III',
		4: 'IV'
	};
	const styleGen = `
		position: relative;
		z-index: 1;
		font-size: 10px;
	`;
	const styleRoot = `
		font-weight: 400;
		display: inline-flex;
		flex-flow: column nowrap;
		justify-content: center;
		align-items: center;
	`;

	const formatted = categories.map(c => {
		if (groupBy === 'QUARTERS') {
			const quarter = moment(c, 'YYYY Q').format('Q');
			const year = moment(c, 'YYYY Q').format('YYYY');

			return `
				<span style="${styleGen}">
					${quarters[quarter]} кв. ${year} г.
				</span>`;
		} else if (groupBy === 'MONTHS') {
			const isSameYear = categories.every(c => moment(c, 'YYYY').isSame(moment(categories[0], 'YYYY')));
			const format = isSameYear ? 'MMMM' : 'MMMM YYYY';
			const monthAndYear = moment(c, 'YYYY MM').format(format);

			return `
				<span style="${styleGen}">
					${monthAndYear.toLocaleLowerCase()} ${isSameYear ? '' : 'г.'}
				</span>`;
		} else if (groupBy === 'WEEKS') {
			const week = moment(c, 'YYYY W').format('W');
			const month = moment(c, 'YYYY W').format('MMMM');
			const year = moment(c, 'YYYY W').format('YYYY');

			return (`
				<span style="${styleRoot + styleGen}">
					<span>${week}-я неделя</span>
					<span>${month} ${year} г.</span>
				</span>
			`);
		}

		return '';
	});

	return formatted;
}

function createDateAndCurrencyTooltipFormatter({ groupBy, categories, prefix }: { groupBy: GroupBy, categories: Array<string>, prefix?: string }) {
	return function () {
		const quarters = {
			1: 'I',
			2: 'II',
			3: 'III',
			4: 'IV'
		};
		const titlePrefix = prefix || `${this.series.name} за`;

		if (groupBy === 'QUARTERS') {
			const quarter = moment(categories[this.x], 'YYYY Q').format('Q');
			const year = moment(categories[this.x], 'YYYY Q').format('YYYY');

			return `<span>${titlePrefix} ${quarters[quarter]} кв. ${year} г.: ${formatCurrency(this.y)}</span>`;
		} else if (groupBy === 'MONTHS') {
			const monthAndYear = moment(categories[this.x], 'YYYY MM').format('MMMM YYYY');

			return `<span>${titlePrefix} ${monthAndYear.toLocaleLowerCase()} г.: ${formatCurrency(this.y)}</span>`;
		} else if (groupBy === 'WEEKS') {
			const week = moment(categories[this.x], 'YYYY W').format('W');
			const year = moment(categories[this.x], 'YYYY W').format('YYYY');

			return `<span>${titlePrefix} ${week}-ю неделю ${year} г.: ${formatCurrency(this.y)}</span>`;
		}

		return `<span>${prefix ? prefix : this.series.name}:  ${formatCurrency(this.y)}</span>`;
	}
}

function createDateAndNumberTooltipFormatter({ groupBy, categories, prefix }: { groupBy: GroupBy, categories: Array<string>, prefix?: string }) {
	return function () {
		const quarters = {
			1: 'I',
			2: 'II',
			3: 'III',
			4: 'IV'
		};
		const titlePrefix = prefix || `${this.series.name} за`;

		if (groupBy === 'QUARTERS') {
			const quarter = moment(categories[this.x], 'YYYY Q').format('Q');
			const year = moment(categories[this.x], 'YYYY Q').format('YYYY');

			return `<span>${titlePrefix} ${quarters[quarter]} кв. ${year} г.: ${this.y}</span>`;
		} else if (groupBy === 'MONTHS') {
			const monthAndYear = moment(categories[this.x], 'YYYY MM').format('MMMM YYYY');

			return `<span>${titlePrefix} ${monthAndYear.toLocaleLowerCase()} г.: ${this.y}</span>`;
		} else if (groupBy === 'WEEKS') {
			const week = moment(categories[this.x], 'YYYY W').format('W');
			const year = moment(categories[this.x], 'YYYY W').format('YYYY');

			return `<span>${titlePrefix} ${week}-ю неделю ${year} г.: ${this.y}</span>`;
		}

		return `<span>${prefix ? prefix : this.series.name}:  ${this.y}</span>`;
	}
}

const chartFormatters = {
	category: {
		formatCategoriesAsDates
	},
	tooltip: {
		createDateAndCurrencyTooltipFormatter,
		createDateAndNumberTooltipFormatter,
	}
};

export {
	chartFormatters
}
